import { Component, ContentChild, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IonButtons, IonFooter, IonToolbar } from '@ionic/angular/standalone';
import { TabPageComponent } from '../tab-page/tab-page.component';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';
import { CrowdctrlSettingsTabPageContent } from './settings-tab-page-content.directive';

@Component({
  selector: 'crowdctrl-settings-list-tab-page',
  standalone: true,
  imports: [TabPageComponent, IonFooter, IonToolbar, IonButtons, LoadingButtonComponent],
  templateUrl: './settings-list-tab-page.component.html',
  styleUrl: './settings-list-tab-page.component.css',
})
export class SettingsListTabPageComponent {
  @Input() pageTitle = '';
  @Input() defaultHref: string | null = null;
  @Input() backButtonIcon?: string;
  @Input() showRefresh = false;
  @Input() loadFn?: () => Observable<unknown>;
  @Input() refreshFn?: () => Observable<unknown>;
  @Input() contentScrollY = true;
  @Input() reloadDataOnEachViewActivation = false;
  @Input() toolbarColor?: string;
  @Input() progressBarColor = 'medium';

  @Input() applyLabel = 'Apply';
  @Input() cancelLabel = 'Cancel';

  /**
   * Prefer `#crowdctrlSettingsTabContent` on the projected settings body: `@ContentChild` by
   * directive class does not match a component that only extends a bare `@Directive()` base.
   */
  @ContentChild('crowdctrlSettingsTabContent')
  private settingsContent?: CrowdctrlSettingsTabPageContent;

  applyBusy = false;
  cancelBusy = false;

  /** Called by the routed host (e.g. `ionViewWillEnter` / `ionViewDidLeave`) to clear Apply/Cancel spinners. */
  resetFooterActions(): void {
    this.clearFooterBusy();
  }

  get footerActionsLocked(): boolean {
    return this.applyBusy || this.cancelBusy;
  }

  get applyDisabled(): boolean {
    return this.footerActionsLocked;
  }

  get cancelDisabled(): boolean {
    return this.footerActionsLocked;
  }

  async onApplyClick(): Promise<void> {
    if (!this.settingsContent || this.footerActionsLocked) {
      return;
    }
    this.applyBusy = true;
    try {
      await this.settingsContent.applySettings();
    } catch {
      this.clearFooterBusy();
    }
  }

  async onCancelClick(): Promise<void> {
    if (!this.settingsContent || this.footerActionsLocked) {
      return;
    }
    this.cancelBusy = true;
    try {
      await this.settingsContent.cancelSettings();
    } catch {
      this.clearFooterBusy();
    }
  }

  private clearFooterBusy(): void {
    this.applyBusy = false;
    this.cancelBusy = false;
  }
}
